export const humanize = string => {
  string = string
    .replace(/[_-]+/g, " ")
    .replace(/\s{2,}/g, " ")
    .replace(/([a-z\d])([A-Z])/g, "$1" + " " + "$2")
    .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, "$1" + " " + "$2")
    .toLowerCase()
    .trim();
  string = string.charAt(0).toUpperCase() + string.slice(1);

  return string;
};
